import * as React from 'react';
import { Typography } from 'omakase';

interface Props {
  iconSrc?: string;
  iconAlt?: string;
  title: string;
  subtitle?: string | React.ReactNode;
  prefix?: string;
}

const ConsumerPageHeading: React.ForwardRefExoticComponent<
  Props & React.RefAttributes<HTMLDivElement>
> = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { iconSrc, iconAlt, prefix, title, subtitle } = props;

  return (
    <div className="ConsumerPageHeading" ref={ref}>
      {iconSrc && (
        <div className="ConsumerPageHeading-logoContainer">
          <img alt={iconAlt} src={iconSrc} className="ConsumerPageHeading-logo" />
        </div>
      )}
      <div className="ConsumerPageHeading-text">
        {prefix && (
          <div className="ConsumerPageHeading-prefix">
            <Typography component="span" variant="body02Strong">
              {prefix}
            </Typography>
          </div>
        )}

        <h1 className="ConsumerPageHeading-title" data-testid="consumer-page-heading-title">
          <Typography component="span" variant="heading01">
            {title}
          </Typography>
        </h1>

        {subtitle && (
          <div className="ConsumerPageHeading-subtitles">
            <div className="ConsumerPageHeading-subtitle">
              <Typography color="inherit" component="span" variant="body02Strong">
                {subtitle}
              </Typography>
            </div>
          </div>
        )}
      </div>
    </div>
  );
});

export default ConsumerPageHeading;
